import { useEffect, useState } from 'react';

const useLayoutReady = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsReady(true), 0);
    return () => clearTimeout(timeout);
  }, []);

  return isReady;
};

export default useLayoutReady;
